











































































import Vue from 'vue'
import ColorPicker from '@/components/ColorPicker.vue'
import { Color } from '@/types'
import {
  GET_COMPANY_SETTINGS,
  CHANGE_COMPANY_SETTINGS,
  CHANGE_COMPANY_SETTINGS_WITH_WALLPAPER
} from '@/store/action-types'
import { CompanySettings } from '@/model/settings/CompanySettings'
import {CompanySettingsPayload} from '@/types/payload'

interface ComponentData {
  defaultColorPrimary: string
  defaultColorSecondary: string
  logo: string | undefined
  favicon: string | undefined
  wallpaper: string | undefined
  primaryColor: string
  secondaryColor: string
  companySettings: CompanySettings | undefined
  showErrorSnackbar: boolean
  showSuccessSnackbar: boolean
  isRemoveWallpaper: boolean
  isRemoveLogo: boolean
  isRemoveFavicon: boolean
  loading: boolean
  showIncorrectFormatSnackbar: boolean
}

interface Payload {
  item: string
  e: EventFile
}

interface EventFile extends Event {
  target: HTMLInputElement & EventTarget
}

enum uploadedFile {
  Logo = 'Logo',
  Favicon = 'Favicon',
  Wallpaper = 'Wallpaper'
}

export default Vue.extend({
  name: 'CompanySettingsPage',

  components: {
    ColorPicker
  },

  data (): ComponentData {
    return {
      defaultColorPrimary: '',
      defaultColorSecondary: '',
      logo: undefined,
      favicon: undefined,
      wallpaper: undefined,
      primaryColor: '',
      secondaryColor: '',
      companySettings: undefined,
      showErrorSnackbar: false,
      showSuccessSnackbar: false,
      isRemoveWallpaper: false,
      isRemoveLogo: false,
      isRemoveFavicon: false,
      loading: false,
      showIncorrectFormatSnackbar: false
    }
  },

  methods: {
    onColorChangePrimary (color: Color): void {
      if (color && color.hex) {
          this.primaryColor = color.hex
      }
    },

    onColorChangeSecondary (color: Color): void {
      if (color && color.hex) {
          this.secondaryColor = color.hex
      }
    },

    onLogoChange(e: EventFile): void {
      const payload: Payload = {item: uploadedFile.Logo, e: e}
      this.onFileChange(payload)
    },

    onFaviconChange(e: EventFile): void {
      const payload: Payload = {item: uploadedFile.Favicon, e: e}
      this.onFileChange(payload)
    },

    onWallpaperChange(e: EventFile): void {
      const payload: Payload = {item: uploadedFile.Wallpaper, e: e}
      this.onFileChange(payload)
    },

    onFileChange(item: Payload): void {
      if (item.e && item.e.target.files) {
        const files: File | undefined = item.e.target.files[0]

        if (files) {
          const reader = new FileReader()

          reader.readAsDataURL(files)
          reader.onload = (e) => {
            if (e.target) {
              if(item.item === uploadedFile.Logo) {
                // @ts-ignore
                if(item.e.target.files[0].type === 'image/png') {
                  // @ts-ignore
                  this.logo = (e.target.result)
                } else {
                  this.logo = undefined
                  this.showIncorrectFormatSnackbar = true
                }
              }
              if(item.item === uploadedFile.Favicon) {
                // @ts-ignore
                if(item.e.target.files[0].type === 'image/x-icon') {
                  // @ts-ignore
                  this.favicon = (e.target.result)
                } else {
                  this.favicon = undefined
                  this.showIncorrectFormatSnackbar = true
                }
              }
              if(item.item === uploadedFile.Wallpaper) {
                // @ts-ignore
                if(item.e.target.files[0].type === 'image/jpeg') {
                  // @ts-ignore
                  this.wallpaper = (e.target.result)
                } else {
                  this.wallpaper = undefined
                  this.showIncorrectFormatSnackbar = true
                }
              }
            }
          }
        }
      }
    },

    onSaveButtonClick(): void {
      this.changeCompanySettings()
    },

    async changeCompanySettings(): Promise<void>{
      if(this.companySettings){
        this.loading = true

        let payload: CompanySettingsPayload = {
          primaryColor: this.primaryColor ? this.primaryColor : '',
          secondaryColor: this.secondaryColor ? this.secondaryColor : '',
          startingDayOfWeek: this.companySettings.startingDayOfWeek,
          qualityByCompetences: this.companySettings.qualityByCompetences,
          qualityByEmployee: this.companySettings.qualityByEmployee,
          logo: this.logo,
          favicon: this.favicon,
          planningWithAddress: this.companySettings.planningWithAddress,
          planDaysPlanWeeksPlanYears: this.companySettings.planDaysPlanWeeksPlanYears,
          weekTimeModel: this.companySettings.weekTimeModel,
          suggestShiftNamesFlag: this.companySettings.suggestShiftNamesFlag,
          nameFormat: this.companySettings.nameFormat,
          provPlanning: this.companySettings.provPlanning,
          nightShiftIndicator: this.companySettings.nightShiftIndicator,
          wallpaper: this.wallpaper,
          isRemoveWallpaper: this.isRemoveWallpaper,
          isRemoveLogo: this.isRemoveLogo,
          isRemoveFavicon: this.isRemoveFavicon,
        }

        try {
          if(this.wallpaper || this.isRemoveWallpaper || this.logo || this.favicon || this.isRemoveLogo || this.isRemoveFavicon) {
            const response = await this.$store.dispatch(CHANGE_COMPANY_SETTINGS_WITH_WALLPAPER, payload)
            if(response) {
              localStorage.setItem('primaryColor', this.primaryColor)
              this.$vuetify.theme.themes.light.primary = this.primaryColor
              localStorage.setItem('secondaryColor', this.secondaryColor)
              this.$vuetify.theme.themes.light.secondary = this.secondaryColor
              document.documentElement.style.setProperty('--primary', this.primaryColor.toString())
              document.documentElement.style.setProperty('--secondary', this.secondaryColor.toString())
              this.wallpaper = undefined
              this.isRemoveWallpaper = false
              this.showSuccessSnackbar = true
              this.logo = undefined
              this.favicon = undefined
              this.isRemoveLogo = false
              this.isRemoveFavicon = false
            } else {
              this.showErrorSnackbar = true
            }
          } else {
            const response = await this.$store.dispatch(CHANGE_COMPANY_SETTINGS, payload)
            if(response) {
              localStorage.setItem('primaryColor', this.primaryColor)
              this.$vuetify.theme.themes.light.primary = this.primaryColor
              localStorage.setItem('secondaryColor', this.secondaryColor)
              this.$vuetify.theme.themes.light.secondary = this.secondaryColor
              document.documentElement.style.setProperty('--primary', this.primaryColor.toString())
              document.documentElement.style.setProperty('--secondary', this.secondaryColor.toString())
              this.showSuccessSnackbar = true
            } else {
              this.showErrorSnackbar = true
            }
          }
          this.loading = false
        } catch(e) {
          this.loading = false
          this.showErrorSnackbar = true
        }
      }
    },

    onRemoveWallpaperClick () {
      this.isRemoveWallpaper = true
      this.changeCompanySettings()
    },

    onRemoveLogoClick () {
      this.isRemoveLogo = true
      this.changeCompanySettings()
    },

    onRemoveFaviconClick () {
      this.isRemoveFavicon = true
      this.changeCompanySettings()
    }

  },

  mounted () {
    this.$store.dispatch(GET_COMPANY_SETTINGS).then((data: CompanySettings) => {
      this.companySettings = data
      this.defaultColorPrimary = data.primaryColor
      this.primaryColor = data.primaryColor
      this.defaultColorSecondary = data.secondaryColor
      this.secondaryColor = data.secondaryColor
      })
    }

})
